<template>
  <div class="page">
    <template v-if="data.state == 0 || data.state == -1 || editing">
      <template v-if="!submited">
        <div class="w1100 v-mt-lg">
          <div class="panel">
            <div class="panel-body">
              <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item :colon="false" v-if="data.state == -1">
                  <span slot="label"></span>
                  <a-alert class="v-mb-sm no-border" type="error">
                    <div slot="message">
                      <div class="font-md text-darkblue flex items-center">
                        <a-icon type="alert" class="v-mr-xs" />
                        此筹款申请已被驳回
                      </div>
                      <div class="flex v-mt-xs">
                        <span class="text-right text-grey">审核意见：</span>
                        <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                      </div>
                    </div>
                  </a-alert>
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目分类
                  </span>
                  <a-radio-group v-model="form.prjCate" button-style="solid" ref="prjCate">
                    <a-radio-button :value="1">短期项目</a-radio-button>
                    <a-radio-button :value="2">长期项目</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目标题
                  </span>
                  <a-input v-model="form.prjName" ref="prjName" placeholder="项目标题" style="width: 100%" />
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目描述
                  </span>
                  <a-textarea :auto-size="{ minRows: 2 }" v-model="form.summary" ref="summary" placeholder="项目描述" style="width: 100%" />
                </a-form-model-item>
                <a-row :gutter="0" v-if="form.prjCate == 1">
                  <a-col span="12">
                    <a-form-model-item :colon="false" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        筹款目标
                      </span>
                      <div class="input-wrapper">
                        <a-input-number v-model="form.raiseAmount" ref="raiseAmount" placeholder="目标金额" style="width: 200px"  class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear />
                        <span class="input-unit">元</span>
                      </div>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false" :label-col="{ span: 10 }" :wrapper-col="{ span: 8 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        筹款时间
                      </span>
                      <a-input type="number" v-model="form.raiseDays" ref="raiseDays" placeholder="筹款天数" style="width: 100%" suffix="天" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-form-model-item :colon="false" v-if="form.prjCate == 1">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目类别
                  </span>
                  <a-radio-group v-model="form.prjType" ref="prjType">
                    <a-radio :value="1">个人项目</a-radio>
                    <a-radio :value="2">其他项目</a-radio>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目话题
                  </span>
                  <a-input v-model="form.topic" ref="topic" placeholder="输入话题" style="width: 300px" prefix="#" suffix="#" />
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目类型
                  </span>
                  <!-- <a-select placeholder="选择项目类型" v-model="form.prjMainType" style="width: 220px" ref="prjMainType">
                    <a-select-option value="动物保护">动物保护</a-select-option>
                    <a-select-option value="环境保护">环境保护</a-select-option>
                    <a-select-option value="教育助学">教育助学</a-select-option>
                    <a-select-option value="医疗救助">医疗救助</a-select-option>
                    <a-select-option value="扶贫助困">扶贫助困</a-select-option>
                    <a-select-option value="救灾应急">救灾应急</a-select-option>
                    <a-select-option value="儿童女性保护">环境保护</a-select-option>
                    <a-select-option value="环境保护">环境保护</a-select-option>
                    <a-select-option value="环境保护">环境保护</a-select-option>
                  </a-select> -->
                  
                  <a-radio-group class="full-width" v-model="form.prjMainType" button-style="solid">
                    <a-row :gutter="[6, 6]">
                      <a-col :span="4" v-for="item in prjTypes" :key="item">
                        <a-radio-button class="text-center v-px-sm" style="width: 100%" :value="item">{{ item }}</a-radio-button>
                      </a-col>
                    </a-row>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item :colon="false" v-if="form.prjCate == 2">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    实施地区
                  </span>
                  <a-cascader change-on-select style="width: 300px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="请根据实际帮扶地区选择执行地点" v-model="form.districts" ref="districts" />
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目简介
                  </span>
                  <tinymce id="myedit" ref="editor" v-model="form.content" :file-params="{ projectId, raiseId, fileType: 102, fileSign: 'PR' }" />
                </a-form-model-item>
              </a-form-model>
            </div>
          </div>
          <div class="text-center v-mt-sm v-mb-lg">
            <a-space>
              <!-- <a-button icon="swap-left" type="indigo" @click="currentStep = 0">返回上一步</a-button> -->
              <a-button icon="check" type="primary" @click="handleConfirm" :loading="saving">提交筹款申请信息</a-button>
              <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
              <a-button icon="undo" type="indigo" @click="handleReset" v-else>重置</a-button>
            </a-space>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的筹款申请信息已提交，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="load">查看已提交信息</a-button>
          </template>
        </a-result>
      </template>
    </template>
    <template v-else-if="[1, 2, 3].includes(data.state)">
      <div class="w960 v-mt-lg">
        <div class="panel">
          <div class="panel-body">
            <a-alert banner :show-icon="false" class="v-mb-sm" type="warning"  v-if="data.state == 1">
              <div slot="message" class="text-grey">此筹款申请于 {{ data.applyTime }} 提交，<a-button icon="form" type="indigo" size="small" @click="editing = true">重新编辑</a-button></div>
            </a-alert>
            <table class="table table-plain">
              <tbody>
                <tr>
                  <th width="150">项目名称</th>
                  <td width="32%">{{ form.prjName }}</td>
                  <th width="150">项目分类</th>
                  <td>
                    <template v-if="form.prjCate == 1">短期项目</template>
                    <template v-else-if="form.prjCate == 2">长期项目</template>
                  </td>
                </tr>
                <tr>
                  <th valign="top">项目描述</th>
                  <td colspan="3" v-html="$utils.convertToHtml(form.summary)"></td>
                </tr>
                <tr v-if="form.prjCate == 1">
                  <th>筹款目标</th>
                  <td>{{ $utils.thousands(form.raiseAmount, 0) }} 元</td>
                  <th>筹款时间</th>
                  <td>{{ form.raiseDays }} 天</td>
                </tr>
                <tr>
                  <th>项目话题</th>
                  <td>#{{ form.topic }}#</td>
                  <th>项目类型</th>
                  <td>{{ form.prjMainType }}</td>
                </tr>
                <tr v-if="form.prjCate == 2">
                  <th valign="top">项目地点</th>
                  <td colspan="3">{{ form.districts ? form.districts.join('') : '' }}</td>
                </tr>
                <tr>
                  <th valign="top">项目简介</th>
                  <td colspan="3" v-html="form.content"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import alldistricts from '@/utils/districts'
import tinymce from '@/components/tinymce'
import { submitRaise, getRaise } from '@/api/project/funded'
const prjTypes = ['动物保护', '环境保护', '教育助学', '医疗救助', '扶贫助困', '救灾应急', '儿童女性保护', '其他']
const form = {
  prjCate: 1,
  prjName: '',
  summary: '',
  raiseAmount: undefined,
  raiseDays: undefined,
  prjType: 1,
  topic: '',
  prjMainType: undefined,
  people: undefined,
  isHiddenName: false,
  districts: [],
  content: '',
}
export default {
  props: {
    raiseId: {
      type: Number,
      required: true,
    },
  },
  components: {
    tinymce,
  },
  data() {
    return {
      projectId: undefined,
      // raiseId: null,
      // currentStep: 0,
      submited: false,
      editing: false,
      saving: false,
      data: {},
      districts: alldistricts,
      prjTypes,
      form: {
        ...form,
      },
      bannerFiles: [],
    }
  },
  methods: {
    load() {
      this.loading = true
      this.editing = false
      getRaise(this.raiseId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { projectId, raiseInfo, raiseNo, files } = result
          this.form = { ...form, ...JSON.parse(raiseInfo || '{}') }
          if (raiseNo) {
            this.form.raiseNo = raiseNo
          }
          this.bannerFiles = files
            .filter(file => file.fileType === 101)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.data = result
          this.projectId = projectId
          this.submited = false
        }
      })
    },
    handleConfirm() {
      this.$message.destroy()
      let { prjCate, prjName, summary, raiseDays, prjMainType, topic, targetCount, districts, raiseAmount, content, } = this.form
      this.$message.destroy()
      if (prjName.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.prjName.focus()
        return
      }
      if (summary.trim() === '') {
        this.$message.warning('请输入项目描述')
        this.$refs.summary.focus()
        return
      }
      if (prjCate == 1) {
        if (!raiseAmount) {
          this.$message.warning('请输入筹款目标金额')
          this.$refs.raiseAmount.focus()
          return
        } 
        if (!raiseDays) {
          this.$message.warning('请输入筹款时间')
          this.$refs.raiseDays.focus()
          return
        }
      }
      if (!topic) {
        this.$message.warning('请输入项目话题')
        this.$refs.topic.focus()
        return
      }
      if (!prjMainType) {
        this.$message.warning('请选择项目捐助分类')
        return
      }
      if (prjCate == 2) {
        if (districts.length === 0) {
          this.$message.warning('请选择项目地点')
          this.$refs.districts.focus()
          return
        }
      }
      if (content.trim() === '') {
        this.$message.warning('请输入项目简介')
        return
      }
      this.$confirm({
        title: '确认提交筹款申请信息？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.saving = true
      let params = {
        files: this.bannerFiles.map(({ fileId }) => ({ fileId })),
        raiseId: this.raiseId,
        raiseInfo: JSON.stringify(this.form),
        projectId: this.projectId,
      }
      this.$message.destroy()
      submitRaise(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.submited = true
          this.$emit('submit')
        } else {
          this.$message.warning(data.msg)
        }
      })
    },
    handleReset() {},
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
  },
  created() {
    this.load()
  },
}
</script>
